<template>
    <div>
        <div v-if="basket.contents.wishlist.items.length > 0" class="grid-x item-container">
            <div class="cell show-for-medium">
                <div class="grid-x headers">
                    <div class="medium-8 large-8 cell">Item Description</div>
                    <div class="medium-4 cell">
                        <div class="grid-x">
                            <div class="medium-4 large-4 cell">Quantity</div>
                            <div class="medium-5 medium-offset-1 large-5 cell">Price</div>
                            <div class="medium-2 cell"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cell">
                <wishlist-item v-for="(item,index) in basket.contents.wishlist.items" v-model="basket.contents.wishlist.items[index]" :key="index"></wishlist-item>
            </div>
            <div v-if="!basket.isLoggedIn" class="cell">
                <p>We will store your list while you browse, but you'll need to <a href="/account/register" style="text-decoration:underline">create an account</a> or sign in to save your wish list between visits. <a href="/account" style="text-decoration:underline">Sign in here</a></p>
            </div>
        </div>
        <div v-else-if="!basket.loaded">
            <p class="text-center" style="margin:1rem auto;">Fetching your list...</p>
        </div>        
        <div v-else-if="basket.loaded">
            <p class="text-center" style="margin:1rem auto;">Your wishlist is empty</p>
        </div>
    </div> 
</template>
<script setup>
    import { useBasketStore } from '@/stores/basket'
    import wishlistItem from './wishlist/wishlist-item.vue'

    const basket = useBasketStore()
</script>